import React from "react";

const EmptySideBar = (props) => {
  return (
    <div>
      <p className="center-text my-2">
        {props.text}
      </p>
    </div>
  );
};

export default EmptySideBar;
